import { cn } from '../../lib/utils'

const shell =
  'rounded-2xl border border-border bg-card text-card-foreground shadow-[var(--shadow-card)] transition-shadow duration-150'

export function Card({ children, className = '', padding = true, hover = false }) {
  return (
    <div
      className={cn(
        shell,
        hover && 'hover:border-border hover:shadow-[var(--shadow-soft)]',
        padding && 'p-6',
        className,
      )}
    >
      {children}
    </div>
  )
}

export function CardHeader({ title, description = null, action = null }) {
  return (
    <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
      <div className="min-w-0">
        {title ? (
          <h2 className="text-lg font-semibold tracking-tight text-foreground">{title}</h2>
        ) : null}
        {description ? (
          <p className="mt-1.5 text-sm leading-relaxed text-muted-foreground">{description}</p>
        ) : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  )
}
